import { isCompleteAddress } from 'platform/shared/health-apps/components/fields/AddressSelectionField';
import { createConfirmPrefill, prefillValue } from './shared';

export const ADDRESS_CONFIRM_KEY = 'view:sponsorAddressIsCorrect';

export const getProfilePrefillAddress = prefillValue('address');

export const hasProfileAddressPrefill = formData =>
  isCompleteAddress(getProfilePrefillAddress(formData));

export const {
  showPrefill: showSponsorAddressPrefill,
  showEntry: showSponsorAddressEntry,
  sync: syncSponsorAddressPrefill,
} = createConfirmPrefill({
  appliedKey: 'view:sponsorAddressPrefillApplied',
  confirmKey: ADDRESS_CONFIRM_KEY,
  hasPrefill: hasProfileAddressPrefill,
  fields: { sponsorAddress: getProfilePrefillAddress },
});
